export const getReviewList = (store) => store.review.data;
export const getPaginationInfo = (store) => {
  const { data, ...rest } = store.review;
  return rest;
};
export const getDoctorList = (store) => store.review.filters.doctor;
export const getPatientList = (store) => store.review.filters.patient;
export const getReviewData = (store) => store.review.reviewData;
